<!-- PRINT CHIMP UNIVERSAL WORKWEAR BUILDER — BLOCK 2 — V3.33 LEAN 4-IMAGE TRADE GALLERY -->
(function(){
 const R=document.getElementById('pc-workwear-builder'); if(!R)return;
 const $=(s,c=R)=>c.querySelector(s), $$=(s,c=R)=>Array.from(c.querySelectorAll(s));
 const money=n=>'£'+Number(n||0).toFixed(2);

 // MERCH BUILDER GARMENT CARD IMAGES — display only
 const MERCH_CARD_IMAGES={
  vests:'https://cdn.shopify.com/s/files/1/1725/3799/files/Custom-Vests.png?v=1790348824',
  caps:'https://cdn.shopify.com/s/files/1/1725/3799/files/Custom-Caps.png?v=1790348824',
  aprons:'https://cdn.shopify.com/s/files/1/1725/3799/files/Custom-Aprons.png?v=1790348823'
 };
 function applyMerchCardImages(){
  Object.entries(MERCH_CARD_IMAGES).forEach(([key,src])=>{
   $$(`[data-start="${key}"] .pcwb-garment-img`).forEach(img=>{
    img.style.backgroundImage=`url("${src}")`;
    img.style.backgroundPosition='center';
    img.style.backgroundRepeat='no-repeat';
    img.style.backgroundSize='cover';
   });
  });
 }

 const CATALOG={
  tshirts:{
    label:'T-Shirts', singular:'T-Shirt', start:'tshirts', icon:'tee',
    eyebrow:'EVERYDAY UNIFORM. CONSISTENT BRAND.',
    title:'BUILD YOUR T-SHIRTS',
    copy:'Create comfortable branded T-shirts that keep your team looking consistent throughout the working day.',
    standard:{handle:'standard-workwear-t-shirt',base:3.95},
    premium:{handle:'premium-workwear-t-shirt',base:5.95},
    cool:{handle:'cool-performance-workwear-t-shirt',base:5.50}
  },
  vests:{
    label:'Vests', singular:'Vest', start:'vests', icon:'tee',
    eyebrow:'LIGHTWEIGHT UNIFORM FOR ACTIVE TEAMS',
    title:'BUILD YOUR VESTS',
    copy:'Branded vests for warmer workplaces, active teams and customer-facing staff.',
    standard:{handle:'standard-vest',base:3.95},
    premium:{handle:'premium-vest',base:5.95},
    cool:{handle:'cool-performance-vest',base:5.50}
  },
  polos:{
    label:'Polos',singular:'Polo',start:'polos',icon:'polo',
    eyebrow:'A SMARTER LOOK FOR YOUR TEAM',
    title:'BUILD YOUR POLOS',
    copy:'A polished uniform option for customer-facing staff and teams that need a smarter look.',
    standard:{handle:'standard-workwear-polo',base:7.95},
    premium:{handle:'premium-workwear-polo',base:11.95}
  },
  hoodies:{
    label:'Hoodies',singular:'Hoodie',start:'hoodies',icon:'hoodie',
    eyebrow:'KEEP YOUR TEAM WARM AND ON-BRAND',
    title:'BUILD YOUR HOODIES',
    copy:'A comfortable branded layer that keeps your team looking consistent in cooler workplaces.',
    standard:{handle:'standard-workwear-hoodie',base:13.85},
    premium:{handle:'premium-workwear-hoodie',base:24.95}
  },
  sweatshirts:{
    label:'Sweatshirts',singular:'Sweatshirt',start:'sweatshirts',icon:'sweatshirt',
    eyebrow:'AN EASY LAYER FOR YOUR WHOLE TEAM',
    title:'BUILD YOUR SWEATSHIRTS',
    copy:'A practical branded layer for staff who need warmth without losing a consistent team look.',
    standard:{handle:'standard-workwear-sweatshirt',base:11.95},
    premium:{handle:'premium-workwear-sweatshirt',base:20.95}
  },
  softshells:{
    label:'Softshells',singular:'Softshell',start:'softshells',icon:'softshell',
    eyebrow:'A SMARTER OUTER LAYER',
    title:'BUILD YOUR SOFTSHELLS',
    copy:'Keep your team looking professional and consistent right through to their outer layer.',
    standard:{handle:'standard-workwear-softshell',base:22.95},
    premium:{handle:'premium-workwear-softshell',base:45.00}
  },
  hivis:{
    label:'Hi-Vis',singular:'Hi-Vis Vest',start:'hivis',icon:'hivis',
    eyebrow:'PRACTICAL VISIBILITY FOR YOUR TEAM',
    title:'BUILD YOUR HI-VIS',
    copy:'Branded hi-vis for staff who need visibility as part of their everyday uniform.',
    standard:{handle:'standard-high-vis-vest',base:3.65}
  },
  caps:{
    label:'Caps',singular:'Cap',start:'caps',icon:'cap',
    eyebrow:'FINISH YOUR UNIFORM',title:'BUILD YOUR CAPS',
    copy:'Printed caps that keep your team branding consistent from head to toe.',
    standard:{handle:'standard-cap',base:3.95},premium:{handle:'premium-mesh-cap',base:5.95}
  },
  aprons:{
    label:'Aprons',singular:'Apron',start:'aprons',icon:'apron',
    eyebrow:'SMART UNIFORM FOR HOSPITALITY TEAMS',
    title:'BUILD YOUR APRONS',
    copy:'Branded aprons for coffee shops, hospitality teams and customer-facing staff.',
    standard:{handle:'standard-waist-apron',base:7.95},
    premium:{handle:'premium-pocket-apron',base:9.95}
  }
};

 const BREAST=[{min:1,max:4,p:4.50},{min:5,max:9,p:3.95},{min:10,max:24,p:3.50},{min:25,max:49,p:2.95},{min:50,max:99999,p:2.50}];
 const BACK=[{min:1,max:4,p:4.95},{min:5,max:9,p:4.50},{min:10,max:24,p:4.25},{min:25,max:49,p:3.75},{min:50,max:99999,p:3.50}];
 const SLEEVE=[{min:1,max:4,p:3.50},{min:5,max:9,p:3.25},{min:10,max:24,p:2.95},{min:25,max:49,p:2.50},{min:50,max:99999,p:2.25}];
 const EMB=[{min:6,max:9,p:5.50},{min:10,max:24,p:4.95},{min:25,max:49,p:4.25},{min:50,max:99999,p:3.75}];

 const SERVICES={
  breastPrint:'left-breast-print',
  centralPrint:'central-print',
  centralEmb:'central-embroidery',
  largeFrontPrint:'large-front-print',
  backPrint:'large-back-print',
  sleevePrint:'sleeve-print',
  breastEmb:'left-breast-embroidery',
  sleeveEmb:'sleeve-embroidery',
  embSetup:'embroidery-setup-1',
  fast:'fast-production',
  express:'express-production'
 };
 const serviceProducts={};

 const HEX={
  Black:'#111111',Navy:'#17233b','French Navy':'#17233b','Royal Blue':'#2459c4',
  'Light Grey':'#d5d5d5',White:'#fafafa',Charcoal:'#4a4a4a',Red:'#c8333b',
  'Classic Red':'#c8333b','Bottle Green':'#214d35','Dark Green':'#214d35',
  'Azure Blue':'#247dc2',Titanium:'#74787b',Yellow:'#e8ef1e','Hi Vis Yellow':'#e8ef1e',
  'Hi-Vis Yellow':'#e8ef1e',Orange:'#f47b20','Hi Vis Orange':'#f47b20'
 };
 const canonicalColour=c=>{
   const s=String(c||'').trim();
   if(/bottle\s*green/i.test(s)||/^dark\s*green$/i.test(s)) return 'Bottle Green';
   if(/^navy$/i.test(s)||/^french\s*navy$/i.test(s)) return s;
   return s;
 };
 const rate=(table,n)=>{const x=table.find(t=>n>=t.min&&n<=t.max);return x?x.p:0};
 const savingPct=(table,n)=>{
   if(!n)return 0;
   const base=table[0].p,current=rate(table,n);
   return current&&current<base?Math.round((1-current/base)*100):0;
 };
 const priceWithSaving=(prefix,price,pct)=>{
   const save=pct>0?` · SAVE ${pct}%`:'';
   return `${prefix}${money(price)} EACH + VAT${save}`;
 };
 const blankSizes=()=>({});
 // LADIES FIT — isolated from Shopify product/variant structure.
 // Ladies quantities use the same underlying Shopify size variants, but are
 // stored separately in the builder and sent to cart as line-item properties.
 const LADIES_UK={XS:'8',S:'10',M:'12',L:'14',XL:'16','2XL':'18'};
 const ladiesSizeKey=s=>'Ladies::'+s;
 const isLadiesSizeKey=s=>String(s||'').startsWith('Ladies::');
 const baseSizeKey=s=>isLadiesSizeKey(s)?String(s).slice(8):String(s);
 const fitForSizeKey=s=>isLadiesSizeKey(s)?'Ladies Fit':'Unisex Fit';
 const displaySizeKey=s=>{
  const base=baseSizeKey(s);
  return isLadiesSizeKey(s)?`Ladies ${sizeShort(base)} (UK ${LADIES_UK[base]||''})`:sizeShort(base);
 };
 const state={
  category:'tshirts',tier:'standard',material:'everyday',colour:null,sizes:blankSizes(),
  method:'print',frontPosition:'leftBreast',back:false,sleeve:false,sleeveSide:'Left',sleeveMethod:'print',
  embSetup:'new',service:'standard',editing:null
 ,fitView:'unisex'};
 let products={},order=[],loading=false;
 let orderEmbSetup=null; // 'new' or 'existing' for the whole order
 let activeKit=null,kitTarget=null;
 // OPTIONAL REAL CUSTOMER WORK GALLERY.
 // Paste Shopify CDN image URLs below when ready. Leave src blank to hide a card.
 const CUSTOMER_WORK=[
   {src:'https://cdn.shopify.com/s/files/1/1725/3799/files/MCS-Embroidery.png?v=1790767411',title:'MCS Group',type:'Branded Uniform'},
   {src:'https://cdn.shopify.com/s/files/1/1725/3799/files/Ashley-Plant-Embroidery.png?v=1790767412',title:'Ashley Plant Hire',type:'Branded Uniform'},
   {src:'https://cdn.shopify.com/s/files/1/1725/3799/files/KCS-Cleaning.png?v=1790767411',title:'KCS Cleaning',type:'Branded T-shirts'}
 ];


 const KITS={
  'sole-trader':{
    title:'SOLE TRADER KIT',
    copy:'A simple branded setup for looking professional every day without over-ordering.',
    items:[
      {category:'tshirts',qty:5,label:'T-Shirts'},
      {category:'polos',qty:1,label:'Polo'},
      {category:'hoodies',qty:1,label:'Hoodie'},
      {category:'hivis',qty:1,label:'Hi-Vis'}
    ]
  },
  professional:{
    title:'PROFESSIONAL KIT',
    copy:'Our recommended all-round setup for a professional trade business.',
    items:[
      {category:'tshirts',qty:5,label:'T-Shirts'},
      {category:'polos',qty:2,label:'Polos'},
      {category:'hoodies',qty:2,label:'Hoodies'},
      {category:'softshells',qty:1,label:'Softshell'},
      {category:'hivis',qty:1,label:'Hi-Vis'}
    ]
  },
  team:{
    title:'TEAM KIT',
    copy:'A stronger setup for growing teams that need consistent branded workwear across the week.',
    items:[
      {category:'tshirts',qty:15,label:'T-Shirts'},
      {category:'polos',qty:6,label:'Polos'},
      {category:'hoodies',qty:6,label:'Hoodies'},
      {category:'softshells',qty:3,label:'Softshells'},
      {category:'hivis',qty:3,label:'Hi-Vis'}
    ]
  }
 };

 function hasPerformanceOption(category){return ['tshirts','vests'].includes(category)}
 function productKey(){
  if(hasPerformanceOption(state.category)&&state.material==='cool')return state.category+':cool';
  return state.category+':'+state.tier;
 }
 function productConfig(){
  const c=CATALOG[state.category];
  return hasPerformanceOption(state.category)&&state.material==='cool'?c.cool:c[state.tier];
 }
 function currentProduct(){return products[productKey()]||null}
 function qty(s=state){return Object.values(s.sizes||{}).reduce((a,b)=>a+(+b||0),0)}
 function normalise(v){return String(v||'').trim().toLowerCase()}
 function optionIndex(p,needle){
  const opts=(p&&p.options)||[];
  let i=opts.findIndex(o=>normalise(typeof o==='string'?o:o.name).includes(needle));
  return i<0?null:i;
 }
 function variantValue(v,i){return i===null?null:(v.options||[])[i]}
 function actualColourFor(p,displayColour){
  if(!p)return displayColour;
  const i=optionIndex(p,'colour') ?? optionIndex(p,'color');
  if(i===null)return displayColour;
  const actual=[...new Set(p.variants.map(v=>variantValue(v,i)).filter(Boolean))];
  return actual.find(c=>canonicalColour(c)===displayColour)||displayColour;
 }
 function coloursFor(p){
  if(!p)return[];
  const i=optionIndex(p,'colour') ?? optionIndex(p,'color');
  if(i===null)return['Default'];
  return [...new Set(p.variants.map(v=>canonicalColour(variantValue(v,i))).filter(Boolean))];
 }
 function sizesFor(p,colour){
  if(!p)return[];
  if(state.category==='caps'||state.category==='aprons')return['One Size'];
  const ci=optionIndex(p,'colour') ?? optionIndex(p,'color'), si=optionIndex(p,'size');
  if(si===null)return[];
  const actual=actualColourFor(p,colour);
  return [...new Set(p.variants.filter(v=>ci===null||variantValue(v,ci)===actual).map(v=>variantValue(v,si)).filter(Boolean))];
 }
 function variantFor(p,colour,size){
  if(!p)return null;
  const ci=optionIndex(p,'colour') ?? optionIndex(p,'color'), si=optionIndex(p,'size');
  const actual=actualColourFor(p,colour);
  const shopifySize=baseSizeKey(size);
  return p.variants.find(v=>(ci===null||variantValue(v,ci)===actual)&&(si===null||variantValue(v,si)===shopifySize))||null;
 }
 // PRODUCT GALLERY — DISPLAY ONLY. Never changes builder/order data.
 // V1 gallery: Product / Your Branding / Get Seen.
 const BRANDING_CLOSEUP='https://cdn.shopify.com/s/files/1/1725/3799/files/Print-Embroidery.png?v=1789833642';
 const BACK_BRANDING='https://cdn.shopify.com/s/files/1/1725/3799/files/Large-Back-Your-Logo.png?v=1790437750';
 // DEFAULT PRODUCT HERO — shown before the customer actively chooses a colour.
 // Paste one dedicated hero image URL per actual Shopify product here.
 const PRODUCT_HEROES={
  'standard-workwear-t-shirt':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Tshirt.png?v=1790700025',
  'premium-workwear-t-shirt':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Tshirt.png?v=1790700025',
  'cool-performance-workwear-t-shirt':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Tshirt.png?v=1790700025',

  'standard-vest':'https://cdn.shopify.com/s/files/1/1725/3799/files/Merch-Vest-Cool-Performance.png?v=1790341074',
  'premium-vest':'https://cdn.shopify.com/s/files/1/1725/3799/files/Merch-Vest-Cool-Performance.png?v=1790341074',
  'cool-performance-vest':'https://cdn.shopify.com/s/files/1/1725/3799/files/Merch-Vest-Cool-Performance.png?v=1790341074',

  'standard-workwear-polo':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Polo.png?v=1790700025',
  'premium-workwear-polo':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Polo.png?v=1790700025',

  'standard-workwear-hoodie':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Hoodie.png?v=1790700025',
  'premium-workwear-hoodie':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Hoodie.png?v=1790700025',

  'standard-workwear-sweatshirt':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Sweatshirt.png?v=1790700025',
  'premium-workwear-sweatshirt':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Sweatshirt.png?v=1790700025',

  'standard-workwear-softshell':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Standard-Softshell.png?v=1790700025',
  'premium-workwear-softshell':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-Premium-Softshell.png?v=1790700026',

  'standard-cap':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-standard-cap.png?v=1790700025',
  'premium-mesh-cap':'https://cdn.shopify.com/s/files/1/1725/3799/files/Uniform-premium-cap.png?v=1790700025',

  'standard-waist-apron':'https://cdn.shopify.com/s/files/1/1725/3799/files/Waist-Apron-Uniform.png?v=1790699878',
  'premium-pocket-apron':'https://cdn.shopify.com/s/files/1/1725/3799/files/Pocket-Apron-Uniform.png?v=1790699916',

  'standard-high-vis-vest':''
 };
 let colourActivelySelected=false,activeTrade='';
 let premiumGalleryIndex=0;
 function imageUrl(img){if(!img)return'';if(typeof img==='string')return img;return img.src||img.url||''}
 function defaultProductHero(){
  const p=currentProduct(),cfg=productConfig();if(!p)return'';
  return (PRODUCT_HEROES[(cfg||{}).handle]||'')||imageUrl(p.featured_image)||imageUrl((p.images||[])[0]);
 }
 function selectedColourHero(){
  const p=currentProduct(),cfg=productConfig();if(!p)return'';
  // Merch Builder uses controlled garment artwork even after a colour is selected.
  // Only products without an override fall back to Shopify variant imagery.
  const override=PRODUCT_HEROES[(cfg||{}).handle]||'';
  if(override)return override;
  const ci=optionIndex(p,'colour') ?? optionIndex(p,'color'),actual=actualColourFor(p,state.colour);
  const v=(p.variants||[]).find(x=>ci===null||variantValue(x,ci)===actual)||(p.variants||[])[0];
  return imageUrl(v&&(v.featured_image||v.image))||defaultProductHero();
 }
 function premiumGallery(){
  return [
   {src:colourActivelySelected?selectedColourHero():defaultProductHero(),label:colourActivelySelected?'SELECTED COLOUR':'PRODUCT'},
   {src:BRANDING_CLOSEUP,label:'YOUR BRANDING'},
   {src:BACK_BRANDING,label:'GET SEEN'}
  ];
 }
 function renderPreviewImage(){
  const art=$('#pcwb-shirt-art'),main=art&&art.closest('.pcwb-product-main');if(!art)return;
  const g=premiumGallery();if(premiumGalleryIndex>=g.length)premiumGalleryIndex=0;
  const item=g[premiumGalleryIndex]||g[0],logo=art.querySelector('span');
  if(item&&item.src){
   art.style.backgroundImage=`url("${String(item.src).replace(/"/g,'%22')}")`;art.style.backgroundColor='transparent';
   art.style.backgroundPosition='center';art.style.backgroundRepeat='no-repeat';art.style.backgroundSize='contain';art.style.clipPath='none';
   art.removeAttribute('data-gallery-label');if(main)main.classList.remove('is-placeholder');if(logo)logo.style.display='none';
  }else{
   art.style.backgroundImage='none';art.style.backgroundColor='#edf2f0';art.style.clipPath='none';
   art.dataset.galleryLabel=((item&&item.label)||'PRODUCT IMAGE')+' PLACEHOLDER';if(main)main.classList.add('is-placeholder');if(logo)logo.style.display='none';
  }
 }
 function renderProductThumbs(){
  const box=$('#pcwb-product-thumbs');if(!box)return;const g=premiumGallery();
  box.innerHTML=g.map((item,i)=>item.src
   ? `<button type="button" class="pcwb-product-thumb ${i===premiumGalleryIndex?'active':''}" data-premium-gallery="${i}" style="background-image:url('${String(item.src).replace(/'/g,"%27")}')" aria-label="${item.label}"></button>`
   : `<button type="button" class="pcwb-product-thumb pcwb-gallery-placeholder ${i===premiumGalleryIndex?'active':''}" data-premium-gallery="${i}" data-label="${item.label}" aria-label="${item.label} placeholder"></button>`
  ).join('');
  $$('[data-premium-gallery]',box).forEach(btn=>btn.onclick=()=>{premiumGalleryIndex=+btn.dataset.premiumGallery;renderPreviewImage();renderProductThumbs()});
 }
 function renderCustomerWork(){
  const sec=$('#pcwb-real-work'),grid=$('#pcwb-real-work-grid');
  if(!sec||!grid)return;
  sec.hidden=false;
  sec.style.display='block';
  const cards=(CUSTOMER_WORK&&CUSTOMER_WORK.length?CUSTOMER_WORK:[
   {src:'',title:'Customer work',type:'Branded workwear'},
   {src:'',title:'Customer work',type:'Branded workwear'},
   {src:'',title:'Customer work',type:'Branded workwear'}
  ]).slice(0,3);
  grid.innerHTML=cards.map((x,i)=>{
   if(x.src){
    return `<div class="pcwb-real-work-card"><img src="${x.src}" alt="${x.title||'Print Chimp customer workwear'}" loading="lazy"><b>${x.title||'Customer work'}</b><span>${x.type||'Branded workwear'}</span></div>`;
   }
   return `<div class="pcwb-real-work-card"><div class="pcwb-real-work-placeholder">REAL CUSTOMER<br>PHOTO ${i+1}</div><b>Customer transformation</b><span>Real Print Chimp workwear</span></div>`;
  }).join('');
 }
 function swatch(c){return HEX[c]||'#7d8582'}
 function sizeShort(s){
  const m={'Small':'S','Medium':'M','Large':'L','Extra Large':'XL','X-Large':'XL','XXL':'2XL','XXXL':'3XL'};
  return m[s]||s;
 }

 function frontPosition(line){
  if(line.category==='caps')return 'centreFront';
  if(line.category==='aprons'){
    return line.method==='embroidery'?'centreFrontEmb':'centreFront';
  }
  return line.frontPosition||'leftBreast';
 }
 function supportsLargeFront(category){return ['tshirts','vests','hoodies','sweatshirts'].includes(category)}
 function totalPrintPool(pools){
  return (pools.breastPrint||0)+(pools.centralPrint||0)+(pools.largeFront||0)+(pools.back||0)+(pools.sleevePrint||0);
 }
 function decorationPools(draft=true){
  const lines=order.map((x,i)=>({...x,_i:i}));
  if(draft&&qty(state))lines.push({...state,qty:qty(state),_draft:true});
  const p={breastPrint:0,centralPrint:0,centralEmb:0,largeFront:0,breastEmb:0,back:0,sleevePrint:0,sleeveEmb:0};
  lines.forEach(x=>{
   const n=x.qty||qty(x),fp=frontPosition(x);
   if(fp==='centreFront')p.centralPrint+=n;
   else if(fp==='centreFrontEmb')p.centralEmb+=n;
   else if(fp==='largeFront')p.largeFront+=n;
   else if(fp==='leftBreast'){if(x.method==='embroidery')p.breastEmb+=n;else p.breastPrint+=n;}
   if(x.back)p.back+=n;
   if(x.sleeve)p.sleevePrint+=n
  });
  return p;
 }
 function totalEmbroideryPool(pools){
  return (pools.breastEmb||0)+(pools.centralEmb||0)+(pools.sleeveEmb||0);
 }
 function lineTotal(line,pools){
  const n=line.qty||qty(line), pc=CATALOG[line.category],fp=frontPosition(line);
  const base=(hasPerformanceOption(line.category)&&line.material==='cool'?pc.cool:pc[line.tier]).base;
  const printQty=totalPrintPool(pools);
  let front=0;
  if(fp==='centreFront')front=rate(BREAST,printQty);
  else if(fp==='centreFrontEmb')front=rate(EMB,totalEmbroideryPool(pools));
  else if(fp==='largeFront')front=rate(BACK,printQty);
  else if(fp==='leftBreast')front=line.method==='embroidery'?rate(EMB,totalEmbroideryPool(pools)):rate(BREAST,printQty);
  const back=line.back?rate(BACK,printQty):0;
  const sleeve=line.sleeve?rate(SLEEVE,printQty):0;
  return n*(base+front+back+sleeve);
 }
 function embroiderySetupTotal(lines){
  const hasEmb=lines.some(x=>['leftBreast','centreFrontEmb'].includes(frontPosition(x))&&x.method==='embroidery');
  if(!hasEmb)return 0;
  const choice=orderEmbSetup || lines.find(x=>['leftBreast','centreFrontEmb'].includes(frontPosition(x))&&x.method==='embroidery'&&x.embSetup)?.embSetup || state.embSetup;
  return choice==='new'?12.50:0;
 }
 function orderTotals(includeDraft=false){
  const lines=order.slice();
  if(includeDraft&&qty(state))lines.push({...state,qty:qty(state)});
  const pools=decorationPools(includeDraft);
  let total=lines.reduce((a,x)=>a+lineTotal(x,pools),0)+embroiderySetupTotal(lines);
  return {lines,pools,total};
 }
 function currentTotal(){
  if(!qty(state))return 0;
  const lines=order.slice();
  if(state.editing!==null)lines.splice(state.editing,1);
  lines.push({...state,qty:qty(state)});
  const pools={breastPrint:0,centralPrint:0,centralEmb:0,largeFront:0,breastEmb:0,back:0,sleevePrint:0,sleeveEmb:0};
  lines.forEach(x=>{
    const n=x.qty||qty(x),fp=frontPosition(x);
    if(fp==='centreFront')pools.centralPrint+=n;
    else if(fp==='centreFrontEmb')pools.centralEmb+=n;
    else if(fp==='largeFront')pools.largeFront+=n;
    else if(fp==='leftBreast'){if(x.method==='embroidery')pools.breastEmb+=n;else pools.breastPrint+=n;}
    if(x.back)pools.back+=n;if(x.sleeve)pools.sleevePrint+=n;
  });
  const draftHasEmb=['leftBreast','centreFrontEmb'].includes(frontPosition(state))&&state.method==='embroidery';
  const setupAlreadyInSavedOrder=order.some(x=>['leftBreast','centreFrontEmb'].includes(frontPosition(x))&&x.method==='embroidery');
  const setupFee=(draftHasEmb&&!setupAlreadyInSavedOrder&&state.embSetup==='new')?12.50:0;
  return lineTotal({...state,qty:qty(state)},pools)+setupFee;
 }
 function currentPools(){
  const lines=order.slice(); if(state.editing!==null)lines.splice(state.editing,1);
  if(qty(state))lines.push({...state,qty:qty(state)});
  const p={breastPrint:0,centralPrint:0,centralEmb:0,largeFront:0,breastEmb:0,back:0,sleevePrint:0,sleeveEmb:0};
  lines.forEach(x=>{
    const n=x.qty||qty(x),fp=frontPosition(x);
    if(fp==='centreFront')p.centralPrint+=n;
    else if(fp==='centreFrontEmb')p.centralEmb+=n;
    else if(fp==='largeFront')p.largeFront+=n;
    else if(fp==='leftBreast'){if(x.method==='embroidery')p.breastEmb+=n;else p.breastPrint+=n;}
    if(x.back)p.back+=n;if(x.sleeve)p.sleevePrint+=n;
  });
  return p;
 }
 function existingPools(){
  const lines=order.slice(); if(state.editing!==null)lines.splice(state.editing,1);
  const p={breastPrint:0,centralPrint:0,centralEmb:0,largeFront:0,breastEmb:0,back:0,sleevePrint:0,sleeveEmb:0};
  lines.forEach(x=>{
    const n=x.qty||qty(x),fp=frontPosition(x);
    if(fp==='centreFront')p.centralPrint+=n;
    else if(fp==='largeFront')p.largeFront+=n;
    else if(fp==='leftBreast'){if(x.method==='embroidery')p.breastEmb+=n;else p.breastPrint+=n;}
    if(x.back)p.back+=n;if(x.sleeve)p.sleevePrint+=n;
  });
  return p;
 }

 async function ensureProduct(){
  const key=productKey(),cfg=productConfig(); if(products[key]||!cfg)return;
  loading=true;R.classList.add('pcwb-loading');
  try{
   const r=await fetch('/products/'+cfg.handle+'.js?pcwb='+Date.now(),{cache:'no-store'}); if(!r.ok)throw new Error(cfg.handle);
   products[key]=await r.json();
  }catch(e){console.warn('Print Chimp Workwear Builder: could not load',cfg.handle,e)}
  loading=false;R.classList.remove('pcwb-loading');
 }
 function resetSizes(){state.sizes={}}
 async function setProductChoice(){
  premiumGalleryIndex=0;
  await ensureProduct();
  const p=currentProduct(),cols=coloursFor(p);
  if(!cols.includes(state.colour))state.colour=cols[0]||'Black';
  const valid=sizesFor(p,state.colour),next={};
  valid.forEach(s=>next[s]=state.sizes[s]||0);
  if(state.category!=='caps'&&state.category!=='aprons'){
   ['XS','S','M','L','XL','2XL'].forEach(s=>{
    const k=ladiesSizeKey(s);
    next[k]=state.sizes[k]||0;
   });
  }
  state.sizes=next;
  renderDynamicOptions();render();
 }
 function renderDynamicOptions(){
  const p=currentProduct(),cols=coloursFor(p),sizes=sizesFor(p,state.colour);
  $('#pcwb-colours').innerHTML=cols.map(c=>`<button class="pcwb-colour ${c===state.colour?'active':''}" data-colour="${String(c).replace(/"/g,'&quot;')}" style="--sw:${swatch(c)}" title="${c}" aria-label="${c}"></button>`).join('');

  const baseLadiesSizes=['XS','S','M','L','XL','2XL'];
  const sizeRow=s=>`<div class="pcwb-size-row" data-size="${String(s).replace(/"/g,'&quot;')}"><b>${isLadiesSizeKey(s)?`${sizeShort(baseSizeKey(s))}<small style="display:block;font-size:10px;font-weight:700;color:#667;">UK ${LADIES_UK[baseSizeKey(s)]}</small>`:sizeShort(s)}</b><button type="button" data-dir="-1" aria-label="Decrease quantity"></button><input class="pcwb-size-input" value="${state.sizes[s]||0}" readonly><button type="button" data-dir="1" aria-label="Increase quantity">+</button></div>`;

  if(state.category==='caps'||state.category==='aprons'){
   $('#pcwb-size-grid').innerHTML=sizes.map(sizeRow).join('');
  }else{
   // Ladies is a presentation/order tag only. Show the full XS–2XL ladies range
   // even when the current unisex Shopify product does not expose every one of
   // those labels. Cart mapping safely falls back to the closest existing size
   // variant only when an exact underlying variant is unavailable.
   baseLadiesSizes.forEach(s=>{
    const k=ladiesSizeKey(s);
    if(state.sizes[k]===undefined)state.sizes[k]=0;
   });
   const fit=state.fitView==='ladies'?'ladies':'unisex';
   $('#pcwb-size-grid').innerHTML=
    `<div class="pcwb-fit-tabs" style="grid-column:1/-1;display:grid;grid-template-columns:1fr 1fr;gap:8px;margin:0 0 14px;">
      <button type="button" data-fit-view="unisex" class="${fit==='unisex'?'active':''}" style="padding:12px 14px;border:1px solid ${fit==='unisex'?'#101820':'#d7ddda'};border-radius:8px;background:${fit==='unisex'?'#101820':'#fff'};color:${fit==='unisex'?'#fff':'#101820'};font-weight:900;cursor:pointer;">UNISEX FIT</button>
      <button type="button" data-fit-view="ladies" class="${fit==='ladies'?'active':''}" style="padding:12px 14px;border:1px solid ${fit==='ladies'?'#101820':'#d7ddda'};border-radius:8px;background:${fit==='ladies'?'#101820':'#fff'};color:${fit==='ladies'?'#fff':'#101820'};font-weight:900;cursor:pointer;">LADIES FIT</button>
    </div>`+
    (fit==='ladies'
      ? baseLadiesSizes.map(s=>sizeRow(ladiesSizeKey(s))).join('')
      : sizes.map(sizeRow).join(''));

   $$('[data-fit-view]').forEach(btn=>btn.onclick=()=>{
    state.fitView=btn.dataset.fitView;
    renderDynamicOptions();
   });
  }

  // Ladies conversion styled to match the existing size-guide presentation.
  const modal=$('#pcwb-size-modal .pcwb-modal-card');
  if(modal){
   let guide=$('#pcwb-ladies-size-guide');
   if(!guide){
    guide=document.createElement('div');
    guide.id='pcwb-ladies-size-guide';
    modal.appendChild(guide);
   }
   guide.hidden=state.category==='caps';
   guide.innerHTML=`
    <div style="margin-top:18px;padding-top:18px;border-top:1px solid #dfe5e2;">
      <b style="display:block;margin-bottom:12px;font-size:13px;letter-spacing:.06em;">LADIES FIT — UK SIZE GUIDE</b>
      <div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;">
       ${baseLadiesSizes.map(s=>`<div style="border:1px solid #d7ddda;border-radius:9px;background:#fff;padding:10px 6px;text-align:center;"><b style="display:block;font-size:13px;">${s}</b><span style="display:block;margin-top:3px;font-size:12px;color:#667;">UK ${LADIES_UK[s]}</span></div>`).join('')}
      </div>
    </div>`;
  }
  bindDynamic();
 }
 function bindDynamic(){
  $$('.pcwb-colour').forEach(x=>x.onclick=()=>{state.colour=x.dataset.colour;colourActivelySelected=true;premiumGalleryIndex=0;resetSizes();setProductChoice()});
  $$('.pcwb-size-row button').forEach(b=>b.onclick=()=>{const row=b.closest('.pcwb-size-row'),s=row.dataset.size,d=+b.dataset.dir;state.sizes[s]=Math.max(0,(state.sizes[s]||0)+d);$('.pcwb-size-input',row).value=state.sizes[s];render()});
 }

 function kitOrderedQty(category){
  return order.filter(x=>x.category===category).reduce((a,x)=>a+(+x.qty||0),0);
 }
 function renderKit(){
  const sec=$('#pcwb-kit'),grid=$('#pcwb-kit-grid'),target=$('#pcwb-kit-target');
  if(!activeKit||!KITS[activeKit]){
    if(sec)sec.hidden=true;
    if(target)target.hidden=true;
    return;
  }
  const kit=KITS[activeKit];
  sec.hidden=false;
  $('#pcwb-kit-title').textContent=kit.title;
  $('#pcwb-kit-copy').textContent=kit.copy;
  grid.innerHTML=kit.items.map(item=>{
    const have=kitOrderedQty(item.category);
    const done=have>=item.qty;
    const remaining=Math.max(0,item.qty-have);
    return `<button class="pcwb-kit-item ${done?'done':''} ${kitTarget&&kitTarget.category===item.category?'active':''}" data-kit-category="${item.category}" data-kit-qty="${item.qty}">
      <strong>${item.label.toUpperCase()}</strong>
      <span>${item.qty}</span>
      <small>${done?'✓ Recommended quantity added':have?`${have} added · ${remaining} still recommended`:'CHOOSE YOUR SIZES →'}</small>
    </button>`;
  }).join('');
  $$('[data-kit-category]',grid).forEach(btn=>btn.onclick=async()=>{
    kitTarget={category:btn.dataset.kitCategory,qty:+btn.dataset.kitQty};
    await setCategory(kitTarget.category,true);
    renderKit();
    render();
  });
  if(kitTarget&&state.category===kitTarget.category){
    const have=kitOrderedQty(kitTarget.category);
    const remaining=Math.max(0,kitTarget.qty-have);
    target.hidden=false;
    target.textContent=remaining
      ? `KIT TARGET: ADD ${remaining} MORE ${CATALOG[kitTarget.category].label.toUpperCase()} — split them across the sizes you need.`
      : `KIT TARGET REACHED: ${kitTarget.qty} ${CATALOG[kitTarget.category].label.toUpperCase()} ADDED ✓`;
  }else target.hidden=true;
 }
 const HERO_BASE='https://cdn.shopify.com/s/files/1/1725/3799/files/';
 const TRADE_HEROES={
  plumber:['Plumbers-Workwear.png?v=1789829731','PLUMBERS & HEATING ENGINEERS'],plumbing:['Plumbers-Workwear.png?v=1789829731','PLUMBERS & HEATING ENGINEERS'],heating:['Plumbers-Workwear.png?v=1789829731','PLUMBERS & HEATING ENGINEERS'],'heating-engineer':['Plumbers-Workwear.png?v=1789829731','PLUMBERS & HEATING ENGINEERS'],
  electrician:['Electricians-Workwear.png?v=1789829731','ELECTRICIANS'],electrical:['Electricians-Workwear.png?v=1789829731','ELECTRICIANS'],
  builder:['BuildingConstruction-Workwear.png?v=1789831571','BUILDERS & CONSTRUCTION'],builders:['BuildingConstruction-Workwear.png?v=1789831571','BUILDERS & CONSTRUCTION'],construction:['BuildingConstruction-Workwear.png?v=1789831571','BUILDERS & CONSTRUCTION'],
  'painter-decorator':['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],painter:['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],painting:['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],'painting-decorating':['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],decorator:['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],
  landscaper:['Landscapers-Workwear.png?v=1789831570','LANDSCAPERS'],landscaping:['Landscapers-Workwear.png?v=1789831570','LANDSCAPERS'],
  roofer:['Roofers-Workwear.png?v=1789831570','ROOFERS'],roofing:['Roofers-Workwear.png?v=1789831570','ROOFERS'],
  joiner:['Joinery-Workwear.png?v=1789831570','JOINERS & CARPENTERS'],joinery:['Joinery-Workwear.png?v=1789831570','JOINERS & CARPENTERS'],carpenter:['Joinery-Workwear.png?v=1789831570','JOINERS & CARPENTERS'],carpentry:['Joinery-Workwear.png?v=1789831570','JOINERS & CARPENTERS'],
    flooring:['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],'floor-fitter':['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],'floor-fitters':['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],floorer:['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],floorers:['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],
  hvac:['Hvac-Workwear.png?v=1789831570','HVAC & AIR CONDITIONING'],'air-conditioning':['Hvac-Workwear.png?v=1789831570','HVAC & AIR CONDITIONING'],'air-con':['Hvac-Workwear.png?v=1789831570','HVAC & AIR CONDITIONING']
 };
 // UNIFORM BUILDER AUDIENCE PERSONALISATION
 const UNIFORM_AUDIENCES={
  coffee:{
   kicker:'COFFEE SHOP UNIFORMS', title:'BUILD YOUR COFFEE SHOP<br><span>UNIFORM.</span>',
   copy:'Create branded T-shirts, polos, aprons and layers for baristas, front-of-house and your wider café team.', cta:'BUILD YOUR COFFEE SHOP UNIFORM',
   image:'https://cdn.shopify.com/s/files/1/1725/3799/files/Coffee-Shop-Tshirts.png?v=1790702652', alt:'Branded coffee shop uniforms for café teams'
  },
  restaurant:{
   kicker:'RESTAURANT UNIFORMS', title:'BUILD YOUR RESTAURANT<br><span>UNIFORM.</span>',
   copy:'Create branded uniforms for front-of-house, kitchen and management teams, from T-shirts and polos to aprons and layers.', cta:'BUILD YOUR RESTAURANT UNIFORM',
   image:'https://cdn.shopify.com/s/files/1/1725/3799/files/Restaurant-Tshirts.png?v=1790715537', alt:'Branded restaurant uniforms for restaurant teams'
  },
  pub:{
   kicker:'PUB & BAR UNIFORMS', title:'BUILD YOUR PUB & BAR<br><span>UNIFORM.</span>',
   copy:'Create branded T-shirts, polos, aprons and layers for bar staff, floor teams and managers.', cta:'BUILD YOUR PUB & BAR UNIFORM',
   image:'https://cdn.shopify.com/s/files/1/1725/3799/files/PubandBar-Staff-Tshirts.png?v=1790715537', alt:'Branded pub and bar uniforms for staff teams'
  },
  hospitality:{
   kicker:'HOSPITALITY UNIFORMS', title:'BUILD YOUR HOSPITALITY<br><span>UNIFORM.</span>',
   copy:'Create consistent branded uniforms for hotels, venues, catering, leisure and customer-facing hospitality teams.', cta:'BUILD YOUR HOSPITALITY UNIFORM',
   image:'https://cdn.shopify.com/s/files/1/1725/3799/files/Hospitality-Tshirts.png?v=1790715537', alt:'Branded hospitality uniforms for customer-facing teams'
  },
  cleaning:{
   kicker:'CLEANING COMPANY UNIFORMS', title:'BUILD YOUR CLEANING TEAM<br><span>UNIFORM.</span>',
   copy:'Create smart branded uniforms for cleaners, supervisors and mobile teams working across customer sites.', cta:'BUILD YOUR CLEANING TEAM UNIFORM',
   image:'https://cdn.shopify.com/s/files/1/1725/3799/files/Cleaning-Company-Uniforms.png?v=1790758667', alt:'Branded cleaning company uniforms for cleaning teams'
  },
  business:{
   kicker:'STAFF & BUSINESS UNIFORMS', title:'BUILD YOUR COMPANY<br><span>UNIFORM.</span>',
   copy:'Create a consistent branded look for offices, shops, warehouses, showrooms, reception teams and service businesses.', cta:'BUILD YOUR COMPANY UNIFORM',
   image:'https://cdn.shopify.com/s/files/1/1725/3799/files/Custom-Company-Uniforms.png?v=1790760619', alt:'Branded staff and business uniforms for company teams'
  }
 };
 const UNIFORM_AUDIENCE_ALIASES={
  cafe:'coffee','coffee-shop':'coffee','coffee-shops':'coffee', restaurants:'restaurant',
  pubs:'pub',bar:'pub',bars:'pub','pub-bar':'pub','pubs-bars':'pub',
  cleaner:'cleaning',cleaners:'cleaning','cleaning-company':'cleaning',
  staff:'business',company:'business','staff-business':'business'
 };
 function uniformPersonalise(audience){
  let key=String(audience||'').trim().toLowerCase();
  key=UNIFORM_AUDIENCE_ALIASES[key]||key;

  const hero=$('#pcwb-hero-image');
  const placeholder=$('.pcwb-hero-placeholder');
  const kicker=$('.pcwb-kicker');
  const title=$('.pcwb-hero-copy h1');
  const copy=$('.pcwb-hero-copy > p');
  const cta=$('.pcwb-hero-copy > .pcwb-btn');

  // No ?for= parameter = generic Uniform Builder.
  if(!key){
   const src='https://cdn.shopify.com/s/files/1/1725/3799/files/uniform-Builder.png?v=1790701331';
   if(hero&&src){
    hero.src=src;
    hero.alt='Branded uniform for your whole team';
    hero.style.display='block';
    if(placeholder)placeholder.style.display='none';
   }
   if(kicker)kicker.textContent='BRANDED UNIFORM FOR YOUR WHOLE TEAM';
   if(title)title.textContent='MAKE YOUR TEAM LOOK THE PART.';
   if(copy)copy.textContent='Branded uniform that keeps your whole team looking smart, professional and consistent.';
   return;
  }

  const c=UNIFORM_AUDIENCES[key];
  if(!c)return;

  const root=$('#pc-workwear-builder');
  if(root)root.dataset.uniformAudience=key;
  if(kicker)kicker.textContent=c.kicker;
  if(title)title.innerHTML=c.title;
  if(copy)copy.textContent=c.copy;
  if(cta)cta.innerHTML=c.cta+' <b>→</b>';
  if(hero&&c.image){
   hero.src=c.image;
   hero.alt=c.alt;
   hero.style.display='block';
   if(placeholder)placeholder.style.display='none';
  }
 }
 function tradePersonalise(trade){
  activeTrade=String(trade||'').trim().toLowerCase();
  const c=TRADE_HEROES[activeTrade],h=$('#pcwb-hero-image'),p=$('.pcwb-hero-placeholder'),k=$('.pcwb-kicker');
  if(h){h.src=c?HERO_BASE+c[0]:'https://cdn.shopify.com/s/files/1/1725/3799/files/uniform-Builder.png?v=1790701331';h.style.display='block';if(p)p.style.display='none'}
  if(k)k.textContent='BRANDED UNIFORM FOR YOUR WHOLE TEAM';
 }
 function setCategory(key,scroll=true){
  if(!CATALOG[key])key='tshirts';
  const previousFrontPosition=state.frontPosition;
  const preservedFrontPosition=supportsLargeFront(key)&&['largeFront','noFront'].includes(previousFrontPosition)
    ? previousFrontPosition
    : 'leftBreast';
  state.category=key;state.material='everyday';state.tier='standard';state.colour=null;state.sizes={};state.editing=null;state.fitView='unisex';state.frontPosition=preservedFrontPosition;colourActivelySelected=false;premiumGalleryIndex=0;
  if(key==='hivis'||key==='caps'||key==='aprons'){
    state.sleeve=false;
    state.sleeveMethod='print';
    const sleeveCheck=$('#pcwb-sleeve');
    if(sleeveCheck)sleeveCheck.checked=false;
  }
  if(key==='caps'){state.method='print';state.back=false;state.sleeve=false;const b=$('#pcwb-back');if(b)b.checked=false;}
  if(key==='aprons'){state.method='print';state.frontPosition='centreFront';state.back=false;state.sleeve=false;const b=$('#pcwb-back');if(b)b.checked=false;}
  const c=CATALOG[key];
  $('#pcwb-config-eyebrow').textContent=c.eyebrow;$('#pcwb-config-title').textContent=c.title;$('#pcwb-config-copy').textContent=c.copy;
  const typeStep=$('#pcwb-type-step');
  typeStep.textContent=key==='tshirts'?'1. CHOOSE YOUR T-SHIRT':'';
  typeStep.style.display=key==='tshirts'?'block':'none';

  $('#pcwb-material-grid').hidden=key!=='tshirts';
  $('#pcwb-quality-wrap').hidden=key==='hivis';
  $('#pcwb-quality-step').textContent=key==='tshirts'?'2. CHOOSE YOUR QUALITY':'1. CHOOSE YOUR QUALITY';

  $$('.pcwb-tier-card[data-tier="premium"]').forEach(x=>x.hidden=key==='hivis');

  if(key==='hivis'||key==='caps'){
    typeStep.style.display='none';
    typeStep.textContent='';
    $('#pcwb-colour-step').textContent=key==='caps'?'2. CHOOSE YOUR COLOUR':'1. CHOOSE YOUR COLOUR';
    $('#pcwb-size-step').textContent=key==='caps'?'3. ADD YOUR QUANTITY':'2. ADD YOUR SIZES & QUANTITIES';
  }else{
    $('#pcwb-colour-step').textContent=(key==='tshirts'?'3.':'2.')+' CHOOSE YOUR COLOUR';
    $('#pcwb-size-step').textContent=(key==='tshirts'?'4.':'3.')+' ADD YOUR SIZES & QUANTITIES';
  }
  $('#pcwb-add-label').textContent='YOUR '+c.label.toUpperCase();
  $('#pcwb-size-guide-title').textContent=c.label.toUpperCase()+' SIZE GUIDE';
  const sleeveBox=$('#pcwb-sleeve')?.closest('.pcwb-sleeve-row');
  if(sleeveBox)sleeveBox.hidden=key==='hivis'||key==='caps'||key==='vests'||key==='aprons';
  $$('.pcwb-garment').forEach(x=>x.classList.toggle('active',x.dataset.start===key));
  setProductChoice();
  if(scroll)$('#pcwb-configurator').scrollIntoView({behavior:'smooth',block:'start'});
 }
 function unitAt(n){
  const cfg=productConfig(); if(!cfg)return 0;
  const fp=frontPosition(state);
  if((fp==='leftBreast'||fp==='centreFrontEmb')&&state.method==='embroidery'&&n<6)return null;
  const front=fp==='none'?0:fp==='largeFront'?rate(BACK,n):fp==='centreFrontEmb'?rate(EMB,n):(state.method==='embroidery'?rate(EMB,n):rate(BREAST,n));
  return cfg.base+front+(state.back?rate(BACK,n):0)+(state.sleeve?rate(SLEEVE,n):0);
 }
 function nextMsg(n){
  const fp=frontPosition(state);
  if(fp==='none')return state.back?'Your front is blank · back print pricing shown below':'No front print selected';
  if(!n)return'Add garments to see your branding price';
  const isEmb=fp==='leftBreast'&&state.method==='embroidery';
  const targets=isEmb?[6,10,25,50]:[5,10,25,50];
  const target=targets.find(t=>t>n);
  if(!target)return'Best branding rate unlocked';
  if(isEmb&&n<6)return`Add ${target-n} more embroidered garment${target-n===1?'':'s'} to reach the 6 garment minimum`;
  return`Add ${target-n} more branded garment${target-n===1?'':'s'} → unlock lower branding prices`;
 }

 function syncStepHeadings(){
  const typeStep=$('#pcwb-type-step');
  if(!typeStep)return;

  if(state.category==='tshirts'){
    typeStep.style.display='block';
    typeStep.textContent='1. CHOOSE YOUR T-SHIRT';
    $('#pcwb-quality-step').textContent='2. CHOOSE YOUR QUALITY';
  }else if(state.category==='hivis'){
    typeStep.style.display='none';
    typeStep.textContent='';
  }else{
    typeStep.style.display='none';
    typeStep.textContent='';
    $('#pcwb-quality-step').textContent=state.category==='caps'?'1. CHOOSE YOUR CAP':'1. CHOOSE YOUR QUALITY';
  }
}

function ensureFrontPositionUI(){
  const primary=$('#pcwb-primary-brand-title')?.closest('.pcwb-brand-row');
  if(!primary||$('#pcwb-front-position'))return;
  const box=document.createElement('div');
  box.id='pcwb-front-position';
  box.style.cssText='display:none;margin:0 0 16px;padding:14px;border:1px solid #e6eaec;border-radius:12px;background:#f6f8f8;';
  box.innerHTML=`<b style="display:block;margin-bottom:10px;font-size:13px;font-weight:900;">WHERE WOULD YOU LIKE YOUR FRONT DESIGN?</b><div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;"><button type="button" data-front-position="leftBreast" style="padding:11px 8px;border:2px solid #dfe5e2;border-radius:9px;background:#fff;font-weight:900;cursor:pointer;">LEFT BREAST</button><button type="button" data-front-position="largeFront" style="padding:11px 8px;border:2px solid #dfe5e2;border-radius:9px;background:#fff;font-weight:900;cursor:pointer;">LARGE FRONT</button><button type="button" data-front-position="none" style="padding:11px 8px;border:2px solid #dfe5e2;border-radius:9px;background:#fff;font-weight:900;cursor:pointer;">NO FRONT</button></div><small id="pcwb-front-position-help" style="display:block;margin-top:9px;color:#667078;line-height:1.4;"></small>`;
  primary.insertBefore(box,primary.querySelector('.pcwb-brand-copy'));
  $$('[data-front-position]',box).forEach(btn=>btn.onclick=()=>{
    state.frontPosition=btn.dataset.frontPosition;
    if(state.frontPosition!=='leftBreast')state.method='print';
    render();
  });
 }
function render(){
  const c=CATALOG[state.category],n=qty(state),pools=currentPools(),cfg=productConfig();
  const isCap=state.category==='caps',isApron=state.category==='aprons',largeFrontOK=supportsLargeFront(state.category),fp=frontPosition(state);
  if(isCap){state.method='print';state.frontPosition='centreFront';state.back=false;state.sleeve=false;}
  if(isApron){state.back=false;state.sleeve=false;if(state.frontPosition!=='none')state.frontPosition='centreFront';}
  if(state.category==='vests'){state.sleeve=false;state.sleeveMethod='print';}
  if(!isCap&&!isApron&&!largeFrontOK&&state.frontPosition!=='leftBreast')state.frontPosition='leftBreast';
  ensureFrontPositionUI();
  const frontChooser=$('#pcwb-front-position');if(frontChooser)frontChooser.style.display=(!isCap&&!isApron&&largeFrontOK)?'block':'none';
  const activeFp=frontPosition(state);
  $$('[data-front-position]',frontChooser||R).forEach(btn=>{const active=btn.dataset.frontPosition===activeFp;btn.style.borderColor=active?'#08B275':'#dfe5e2';btn.style.background=active?'#f0fff9':'#fff';});
  const frontHelp=$('#pcwb-front-position-help');if(frontHelp)frontHelp.textContent=activeFp==='largeFront'?'Large centred print · print only':activeFp==='none'?'No decoration on the front':'Small left-breast logo · choose print or embroidery below';
  const methods=$('.pcwb-methods');if(methods)methods.style.display=(isCap||(!isApron&&activeFp!=='leftBreast')||activeFp==='none')?'none':'';
  const backRow=$('#pcwb-back')?.closest('.pcwb-brand-row');if(backRow)backRow.hidden=isCap||isApron;
  const sleeveRow=$('#pcwb-sleeve')?.closest('.pcwb-sleeve-row');if(sleeveRow)sleeveRow.hidden=isCap||state.category==='hivis'||state.category==='vests'||state.category==='aprons';
  const sizeGuide=$('#pcwb-size-guide-open-2');if(sizeGuide)sizeGuide.hidden=isCap||state.category==='aprons';
  const primaryTitle=$('#pcwb-primary-brand-title');if(primaryTitle)primaryTitle.textContent=isCap?'YOUR CENTRE FRONT PRINT IS INCLUDED':isApron?'YOUR CENTRE FRONT DESIGN':activeFp==='largeFront'?'YOUR LARGE FRONT PRINT':activeFp==='none'?'NO FRONT PRINT':'YOUR LEFT BREAST DESIGN';
  const primaryCopy=$('#pcwb-primary-brand-copy');if(primaryCopy)primaryCopy.textContent=isCap?'Add your logo, event branding or design to the centre front of your cap. Print is included.':isApron?'Add your logo to the centre front and choose print or embroidery.':activeFp==='largeFront'?'A large centred print for event, charity and merch designs.':activeFp==='none'?'Leave the front blank and add back or sleeve branding if you need it.':'Add a small left-breast design and choose print or embroidery.';
  const sc=$('.pcwb-tier-card[data-tier="standard"]'),pc=$('.pcwb-tier-card[data-tier="premium"]');
  if(sc){
    const h=sc.querySelector('h3'),p=sc.querySelector('p'),m=sc.querySelector('.pcwb-mini-points'),s=sc.querySelector('small');
    if(h)h.textContent=isCap?'Standard Cap':isApron?'Standard Waist Apron':'Reliable everyday uniform';
    if(p)p.textContent=isCap?'A practical branded cap for staff and customer-facing teams.':isApron?'A practical waist apron for everyday service — ideal for coffee shops, cafés, bars and hospitality teams.':"A practical everyday option for businesses that need comfortable, consistent staff uniform.";
    if(m)m.textContent=isCap?'✓ Classic cap · ✓ Great value · ✓ One size':isApron?'✓ Waist length · ✓ Practical everyday uniform · ✓ One size':'✓ Great value · ✓ Comfortable fit · ✓ Everyday uniform';
    if(s)s.textContent=isCap?'CENTRE FRONT PRINT INCLUDED':isApron?'CENTRE FRONT BRANDING':'LEFT BREAST PRINT INCLUDED';
  }
  if(pc){
    const h=pc.querySelector('h3'),p=pc.querySelector('p'),m=pc.querySelector('.pcwb-mini-points'),s=pc.querySelector('small');
    if(h)h.textContent=isCap?'Premium Mesh Cap':isApron?'Premium Full Length Pocket Apron':'A smarter premium finish';
    if(p)p.textContent=isCap?'A premium mesh-back cap for teams that want a more distinctive staff uniform.':isApron?'A full length apron with a useful front pocket for a smarter, more complete hospitality uniform.':'An upgraded garment with a better feel and finish for customer-facing teams.';
    if(m)m.textContent=isCap?'✓ Premium finish · ✓ Mesh back · ✓ One size':isApron?'✓ Full length · ✓ Front pocket · ✓ One size':'✓ Premium feel · ✓ Better finish · ✓ Smarter uniform';
    if(s)s.textContent=isCap?'CENTRE FRONT PRINT INCLUDED':isApron?'CENTRE FRONT BRANDING':'LEFT BREAST PRINT INCLUDED';
  }


  // Keep every control visually synced with state. This is especially important
  // when reopening an existing order line with EDIT.
  const backBox=$('#pcwb-back'); if(backBox)backBox.checked=!!state.back;
  const sleeveBoxCheck=$('#pcwb-sleeve'); if(sleeveBoxCheck)sleeveBoxCheck.checked=!!state.sleeve;

  $$('input[name="pcwb-method"]').forEach(x=>{
    x.checked=x.value===state.method;
    const label=x.closest('label');
    if(label)label.classList.toggle('active',x.checked);
  });
  if(orderEmbSetup)state.embSetup=orderEmbSetup;
  $$('input[name="pcwb-emb-setup"]').forEach(x=>{
    x.checked=x.value===state.embSetup;
    x.disabled=false;
    const label=x.closest('label');
    if(label)label.classList.toggle('active',x.checked);
  });

  const embExisting=$('#pcwb-embroidery-existing');
  if(embExisting){
    let status=embExisting.querySelector('.pcwb-order-emb-status');
    const normalChildren=[...embExisting.children].filter(el=>!el.classList.contains('pcwb-order-emb-status'));
    if(orderEmbSetup && state.editing===null){
      normalChildren.forEach(el=>el.style.display='none');
      if(!status){
        status=document.createElement('div');
        status.className='pcwb-order-emb-status';
        status.style.cssText='padding:16px 18px;border:2px solid #08B275;border-radius:12px;background:#f3fff9;';
        embExisting.appendChild(status);
      }
      status.style.display='block';
      status.innerHTML=orderEmbSetup==='new'
        ? `<strong style="display:block;font-size:15px;font-weight:900;color:#111;">ONE SETUP COVERS YOUR WHOLE ORDER ✓</strong><span style="display:block;margin-top:6px;font-size:13px;line-height:1.45;color:#333;">New embroidery logo — £15 inc VAT one-time setup. Add embroidery to any other garments without another setup charge.</span>`
        : `<strong style="display:block;font-size:15px;font-weight:900;color:#111;">YOUR EMBROIDERY LOGO IS ALREADY ON FILE ✓</strong><span style="display:block;margin-top:6px;font-size:13px;line-height:1.45;color:#333;">No setup charge. Add embroidery to any other garments in this order.</span>`;
    }else{
      normalChildren.forEach(el=>el.style.display='');
      if(status)status.style.display='none';
    }
  }
  $$('input[name="pcwb-sleeve-side"]').forEach(x=>{
    x.checked=x.value===state.sleeveSide;
    const label=x.closest('label');
    if(label)label.classList.toggle('active',x.checked);
  });

  $('#pcwb-total-qty').textContent=n;$('#pcwb-add-qty').textContent=n;$('#pcwb-add-total').textContent=money(currentTotal());
  $('#pcwb-colour-name').textContent=state.colour||'—';$('#pcwb-preview-colour').textContent=state.colour||'—';
  const quality=hasPerformanceOption(state.category)&&state.material==='cool'?'Cool Performance':state.tier==='premium'?'Premium':'Standard';
  $('#pcwb-preview-name').textContent=quality+' '+c.singular;
  renderPreviewImage();
  renderProductThumbs();
  renderCustomerWork();
  const pooledPrintQty=totalPrintPool(pools);
  const activeFrontQty=(activeFp==='centreFrontEmb')?(pools.breastEmb+pools.centralEmb):(activeFp==='leftBreast'&&state.method==='embroidery')?(pools.breastEmb+pools.centralEmb):pooledPrintQty;
  $('#pcwb-next-tier').textContent=nextMsg(activeFrontQty);
  $$('.pcwb-material-card').forEach(x=>x.classList.toggle('active',x.dataset.material===state.material));
  $$('.pcwb-tier-card').forEach(x=>x.classList.toggle('active',x.dataset.tier===state.tier));
  $('#pcwb-material-grid').hidden=!hasPerformanceOption(state.category);
  $('#pcwb-cool-note').hidden=!(hasPerformanceOption(state.category)&&state.material==='cool');
  if(hasPerformanceOption(state.category)){
    $('#pcwb-quality-wrap').hidden=state.material==='cool';
    $('#pcwb-quality-step').textContent='2. CHOOSE YOUR QUALITY';
  }else{
    $('#pcwb-quality-wrap').hidden=state.category==='hivis';
    $('#pcwb-quality-step').textContent=state.category==='caps'?'1. CHOOSE YOUR CAP':'1. CHOOSE YOUR QUALITY';
  }

  // Correct "from branded" prices: base + 50+ left breast print.
  $('#pcwb-standard-from').textContent=money((CATALOG[state.category].standard||{base:0}).base+2.50);
  const prem=CATALOG[state.category].premium;
  $('#pcwb-premium-from').textContent=prem?money(prem.base+2.50):'—';
  $('#pcwb-cool-from').textContent=money((CATALOG[state.category].cool||CATALOG.tshirts.cool).base+2.50);

  const ids=['#pcwb-price-1','#pcwb-price-5','#pcwb-price-10','#pcwb-price-25','#pcwb-price-50'];
  const ladderCells=$$('.pcwb-price-ladder>div');
  const ladderEmbroidery=(frontPosition(state)==='centreFrontEmb')||(frontPosition(state)==='leftBreast'&&state.method==='embroidery');
  if(ladderEmbroidery){
    const embNs=[6,10,25,50];
    const embLabels=['6–9','10–24','25–49','50+'];
    if(ladderCells[0])ladderCells[0].style.display='none';
    for(let i=1;i<5;i++){
      if(ladderCells[i]){
        ladderCells[i].style.display='';
        ladderCells[i].dataset.min=String(embNs[i-1]);
        ladderCells[i].dataset.max=String(i===4?99999:embNs[i]-1);
        const sm=ladderCells[i].querySelector('small');if(sm)sm.textContent=embLabels[i-1];
      }
      const v=unitAt(embNs[i-1]);
      $(ids[i]).textContent=v===null?'—':money(v);
    }
  }else{
    const printNs=[1,5,10,25,50],printLabels=['1–4','5–9','10–24','25–49','50+'];
    ladderCells.forEach((cell,i)=>{
      cell.style.display='';
      cell.dataset.min=String(printNs[i]);
      cell.dataset.max=String(i===4?99999:printNs[i+1]-1);
      const sm=cell.querySelector('small');if(sm)sm.textContent=printLabels[i];
      const v=unitAt(printNs[i]);$(ids[i]).textContent=v===null?'6+ ONLY':money(v);
    });
  }
  // All PRINT applications share one quantity tier across the whole order.
  // Embroidery remains a separate pool.
  const isFrontEmbroidery=(activeFp==='centreFrontEmb')||(activeFp==='leftBreast'&&state.method==='embroidery');
  const embroideryPool=totalEmbroideryPool(pools);
  const pooledBreast=isFrontEmbroidery ? embroideryPool : pooledPrintQty;
  $$('.pcwb-price-ladder>div').forEach(x=>{const a=+x.dataset.min,b=+x.dataset.max;x.classList.toggle('active',pooledBreast>=a&&pooledBreast<=b)});
  $('#pcwb-pool-status').textContent=isFrontEmbroidery
    ? 'Mix & match embroidered garments — the more items you embroider, the less you pay per embroidery.'
    : 'Mix & match your uniform — eligible branding quantities are combined automatically.';
  const selected=[isCap?'Centre front print':activeFp==='centreFrontEmb'?'Centre front embroidery':activeFp==='centreFront'?'Centre front print':activeFp==='largeFront'?'Large front print':activeFp==='none'?'No front print':(state.method==='embroidery'?'Left breast embroidery':'Left breast print')];
  if(state.back)selected.push('Large back print');
  if(state.sleeve)selected.push((state.sleeveSide||'Left')+' sleeve print');
  const breastRateNow=activeFp==='none'?0:activeFp==='largeFront'?rate(BACK,pooledBreast):isFrontEmbroidery?rate(EMB,pooledBreast):rate(BREAST,pooledBreast);
  const breastTable=activeFp==='largeFront'?BACK:(isFrontEmbroidery?EMB:BREAST);
  const breastSave=savingPct(breastTable,pooledBreast);
  const ladderLabel=isCap?'CENTRE FRONT PRINT':activeFp==='centreFrontEmb'?'CENTRE FRONT EMBROIDERY':activeFp==='largeFront'?'LARGE FRONT PRINT':activeFp==='none'?'NO FRONT PRINT':(state.method==='embroidery'?'LEFT BREAST EMBROIDERY':'LEFT BREAST PRINT');
  $('.pcwb-ladder-title span').textContent=pooledBreast
    ? `${ladderLabel} · ${activeFp==='none'?'£0.00':money(breastRateNow)+' EACH + VAT'}${breastSave?` · SAVE ${breastSave}%`:''}`
    : selected.join(' + ');

  // Preview optional print upgrades against the universal PRINT pool.
  // If the option is not selected yet, include the extra applications it would add.
  const previewBackQty=pooledPrintQty+(state.back?0:n);
  const previewSleeveQty=pooledPrintQty+(state.sleeve?0:n);

  if(n){
    const br=rate(BACK,previewBackQty);
    const backSave=savingPct(BACK,previewBackQty);
    $('#pcwb-back-rate').textContent=`+${money(br)} EACH + VAT${backSave?` · SAVE ${backSave}%`:''}`;

    const sleeveTable=SLEEVE;
    const sr=rate(SLEEVE,previewSleeveQty);
    const sleeveSave=savingPct(sleeveTable,previewSleeveQty);
    $('#pcwb-sleeve-rate').textContent=`+${money(sr)} EACH + VAT${sleeveSave?` · SAVE ${sleeveSave}%`:''}`;
  }else{
    $('#pcwb-back-rate').textContent='ADD SIZES TO SEE YOUR PRICE';
    $('#pcwb-sleeve-rate').textContent='ADD SIZES TO SEE YOUR PRICE';
  }

  const activeEmbroidery=(activeFp==='leftBreast'||activeFp==='centreFrontEmb')&&state.method==='embroidery';
  const totalEmbroidery=(pools.breastEmb||0)+(pools.centralEmb||0);
  $('#pcwb-embroidery-panel').hidden=!activeEmbroidery;
  const embWarning=$('#pcwb-embroidery-warning');
  embWarning.style.display=(activeEmbroidery&&totalEmbroidery<6)?'block':'none';
  if(activeEmbroidery&&totalEmbroidery<6){
    embWarning.textContent=`Embroidery has a 6 garment minimum across your whole order. You currently have ${totalEmbroidery}/6 — you can add this item now and add the remaining embroidered garments afterwards.`;
  }
  $('#pcwb-embroidery-existing').style.display=activeEmbroidery?'block':'none';
  const sleevePanel=$('#pcwb-accreditation-panel');
   if(sleevePanel){
     sleevePanel.hidden=!state.sleeve||state.category==='vests';
     const sleeveUpsellImg=sleevePanel.querySelector('img');
     if(sleeveUpsellImg){
       sleeveUpsellImg.src='https://cdn.shopify.com/s/files/1/1725/3799/files/Pchimp-Sleeve-Print.png?v=1789766110';
       sleeveUpsellImg.alt='Custom sleeve print';
     }
   }

  const invalid=!n;
  $('#pcwb-add-order').disabled=invalid;$('#pcwb-add-order').classList.toggle('disabled',invalid);
  $('#pcwb-add-order').textContent=state.editing===null?'ADD TO ORDER →':'UPDATE GARMENT →';
  renderOrder();renderService();renderKit();
 }

 function renderOrder(){
  const sec=$('#pcwb-order'),box=$('#pcwb-order-items');
  if(!order.length){sec.hidden=true;box.innerHTML='';return}
  sec.hidden=false;
  const pools=decorationPools(false);
  const poolBits=[];
  if(pools.breastPrint)poolBits.push(`${pools.breastPrint} left-breast prints`);
   if(pools.centralPrint)poolBits.push(`${pools.centralPrint} centre-front prints`);
  if(pools.largeFront)poolBits.push(`${pools.largeFront} large-front prints`);
  if(pools.breastEmb)poolBits.push(`${pools.breastEmb} left-breast embroideries`);
  if(pools.centralEmb)poolBits.push(`${pools.centralEmb} centre-front embroideries`);
  if(pools.back)poolBits.push(`${pools.back} back prints`);
  if(pools.sleevePrint)poolBits.push(`${pools.sleevePrint} sleeve prints`);
  
  box.innerHTML=`<div class="pcwb-pooling-note">✓ ALL PRINTS COUNT TOGETHER FOR QUANTITY PRICING: ${poolBits.join(' · ')}</div>`+
   order.map((x,i)=>{
    const ss=Object.entries(x.sizes).filter(v=>v[1]).map(([s,q])=>`${displaySizeKey(s)} × ${q}`).join(' · ');
    const xfp=frontPosition(x);const br=[xfp==='centreFrontEmb'?'Centre front embroidery':xfp==='centreFront'?'Centre front print':xfp==='largeFront'?'Large front print':xfp==='none'?'No front print':(x.method==='embroidery'?'Left breast embroidery':'Left breast print')];if(x.back)br.push('Back print');if(x.sleeve)br.push(`${x.sleeveSide||'Left'} sleeve print`);
    const quality=hasPerformanceOption(x.category)&&x.material==='cool'?'Cool Performance':x.tier==='premium'?'Premium':'Standard';
    return `<div class="pcwb-order-item"><div><b>${x.qty} × ${quality} ${CATALOG[x.category].label}</b><span>${x.colour} · ${ss} · ${br.join(' · ')}</span></div><strong>${money(lineTotal(x,pools))} + VAT</strong><div class="pcwb-order-actions"><button data-edit="${i}">EDIT</button><button class="pcwb-remove" data-remove="${i}">REMOVE</button></div></div>`
   }).join('');
  $$('[data-edit]',box).forEach(b=>b.onclick=()=>editLine(+b.dataset.edit));
  $$('[data-remove]',box).forEach(b=>b.onclick=()=>{
    order.splice(+b.dataset.remove,1);
    if(!order.some(x=>x.method==='embroidery')){
      orderEmbSetup=null;
      state.embSetup='new';
    }
    render();
  });
 }
 async function editLine(i){
  const x=order[i]; if(!x)return;
  Object.assign(state,{...x,sizes:{...x.sizes},editing:i});
  colourActivelySelected=true;premiumGalleryIndex=0;
  if(!state.method)state.method='print';
  if(!state.frontPosition)state.frontPosition='leftBreast';
  if(!state.sleeveMethod)state.sleeveMethod='print';
  if(state.category==='hivis'){state.sleeve=false;state.sleeveMethod='print'}
  if(state.category==='caps'){state.method='print';state.back=false;state.sleeve=false;state.sleeveMethod='print'}
  if(state.category==='vests'){state.sleeve=false;state.sleeveMethod='print'}
  const sleeveBox=$('#pcwb-sleeve')?.closest('.pcwb-sleeve-row');
  if(sleeveBox)sleeveBox.hidden=state.category==='hivis'||state.category==='caps'||state.category==='vests';
  await ensureProduct();renderDynamicOptions();render();
  $('#pcwb-configurator').scrollIntoView({behavior:'smooth',block:'start'});
 }
 function renderService(){
  const totals=orderTotals(false),base=totals.total;

  // Embroidery anywhere in the saved order OR current configurator means Standard only.
  const savedEmbroidery=order.some(x=>['leftBreast','centreFrontEmb'].includes(frontPosition(x))&&x.method==='embroidery');
  const draftEmbroidery=qty(state)>0 && ['leftBreast','centreFrontEmb'].includes(frontPosition(state))&&state.method==='embroidery';
  const hasEmbroidery=savedEmbroidery||draftEmbroidery;
  const savedEmbroideryQty=totalEmbroideryPool(totals.pools);
  const embroideryMinimumPending=savedEmbroideryQty>0&&savedEmbroideryQty<6;

  const standard=$('input[name="pcwb-service"][value="standard"]');
  const fast=$('input[name="pcwb-service"][value="fast"]');
  const express=$('input[name="pcwb-service"][value="express"]');

  [fast,express].forEach(x=>{
    if(!x)return;
    x.disabled=hasEmbroidery;
    const card=x.closest('label');
    if(card){
      card.style.display=hasEmbroidery?'none':'';
      card.style.opacity='';
      card.style.cursor='';
      card.classList.remove('active');
    }
  });

  if(standard){
    const card=standard.closest('label');
    if(card)card.style.display='';
  }

  if(hasEmbroidery){
    state.service='standard';
    if(standard)standard.checked=true;
    if(fast)fast.checked=false;
    if(express)express.checked=false;
  }

  let fee=0;
  let label=embroideryMinimumPending
    ? `Embroidery minimum: ${savedEmbroideryQty}/6 garments · add ${6-savedEmbroideryQty} more embroidered garment${6-savedEmbroideryQty===1?'':'s'}`
    : hasEmbroidery?'Standard service · Embroidery orders':'Standard service included';

  const garmentQty=order.reduce((sum,x)=>sum+(+x.qty||0),0);

  if(!hasEmbroidery&&state.service==='fast'){
    fee=garmentQty*2.99;
    label='Fast production · '+garmentQty+' garment'+(garmentQty===1?'':'s')+' · '+money(fee)+' + VAT';
  }
  if(!hasEmbroidery&&state.service==='express'){
    fee=garmentQty*4.99;
    label='Express production · '+garmentQty+' garment'+(garmentQty===1?'':'s')+' · '+money(fee)+' + VAT';
  }

  const checkoutEx=base+fee;
  const checkoutInc=checkoutEx*1.20;
  $('#pcwb-checkout-total').innerHTML=
    `<div style="display:flex;align-items:baseline;gap:10px;flex-wrap:nowrap;white-space:nowrap;font-weight:900;line-height:1.1"><span style="font-size:1.18em;color:#ffffff !important">${money(checkoutEx)}</span><span style="font-size:.78em;color:#ffffff !important">EX VAT</span></div>`+
    `<div style="display:flex;align-items:baseline;gap:10px;flex-wrap:nowrap;white-space:nowrap;margin-top:8px;font-weight:900;line-height:1.1"><span style="font-size:1.05em;color:#08B275 !important">${money(checkoutInc)}</span><span style="font-size:.82em;color:#08B275 !important">INC VAT</span></div>`;
  $('#pcwb-service-summary').textContent=label;
  $$('.pcwb-service-grid label').forEach(l=>{
    const input=l.querySelector('input');
    if(input)l.classList.toggle('active',input.value===state.service);
  });
  const checkoutBlocked=!order.length||embroideryMinimumPending;
  $('#pcwb-checkout').disabled=checkoutBlocked;
  $('#pcwb-checkout').classList.toggle('disabled',checkoutBlocked);
  $('#pcwb-checkout').textContent=embroideryMinimumPending
    ? `ADD ${6-savedEmbroideryQty} MORE EMBROIDERED GARMENT${6-savedEmbroideryQty===1?'':'S'}`
    : 'CONTINUE TO CHECKOUT →';
 }

 $$('.pcwb-material-card').forEach(x=>x.onclick=async()=>{state.material=x.dataset.material;colourActivelySelected=false;premiumGalleryIndex=0;resetSizes();await setProductChoice()});
 $$('.pcwb-tier-card').forEach(x=>x.onclick=async()=>{state.tier=x.dataset.tier;colourActivelySelected=false;premiumGalleryIndex=0;resetSizes();await setProductChoice()});
 $$('input[name="pcwb-method"]').forEach(x=>x.onchange=()=>{
   state.method=x.value;
   render();
 });
 $$('input[name="pcwb-emb-setup"]').forEach(x=>x.onchange=()=>{
   state.embSetup=x.value;
   if(!orderEmbSetup)orderEmbSetup=x.value;
   render();
 });
 $('#pcwb-back').onchange=e=>{state.back=e.target.checked;render()};
 $('#pcwb-sleeve').onchange=e=>{state.sleeve=e.target.checked;render()};
 $$('input[name="pcwb-sleeve-side"]').forEach(x=>x.onchange=()=>{state.sleeveSide=x.value;render()});
 $$('input[name="pcwb-service"]').forEach(x=>x.onchange=()=>{state.service=x.value;render()});
 $$('[data-start]').forEach(x=>x.onclick=()=>{
   kitTarget=null;
   setCategory(x.dataset.start,true);
 });
 const kitClear=$('#pcwb-kit-clear');
 if(kitClear)kitClear.onclick=()=>{
   activeKit=null;kitTarget=null;renderKit();
   const u=new URL(location.href);u.searchParams.delete('kit');history.replaceState({},'',u);
 };

 $('#pcwb-add-order').onclick=async()=>{
  const n=qty(state),p=currentPools();
  if(!n)return;

  const wasEditing=state.editing!==null;
  const line={...state,sizes:{...state.sizes},qty:n}; delete line.editing;
  const lineHasEmb=['leftBreast','centreFrontEmb'].includes(frontPosition(line))&&line.method==='embroidery';
  if(lineHasEmb){
    if(!orderEmbSetup)orderEmbSetup=line.embSetup||state.embSetup||'new';
    line.embSetup=orderEmbSetup;
  }
  if(state.editing===null)order.push(line);else order[state.editing]=line;
  state.editing=null;

  // A saved line now lives safely in the order. For a NEW addition, clear the
  // size quantities so reopening this garment starts at zero instead of making
  // the customer manually remove the quantities they just added.
  // EDIT still restores the saved quantities via editLine().
  if(!wasEditing) resetSizes();
  renderDynamicOptions();
  render();

  // Guided recommended-kit flow:
  // after adding a garment, move straight to the next incomplete garment
  // instead of dropping the customer down to the order / "Add More Workwear" area.
  if(activeKit&&!wasEditing&&KITS[activeKit]){
    const next=KITS[activeKit].items.find(item=>kitOrderedQty(item.category)<item.qty);
    if(next){
      kitTarget={category:next.category,qty:next.qty};
      await setCategory(next.category,true);
      renderKit();
      render();
      return;
    }
  }

  $('#pcwb-order').scrollIntoView({behavior:'smooth',block:'start'});
 };

 const modal=$('#pcwb-size-modal');

function openSize(){
  if(modal) modal.hidden=false;
}

function closeSize(){
  if(modal) modal.hidden=true;
}

const sizeGuideBtn=$('#pcwb-size-guide-open-2');
const sizeGuideClose=$('.pcwb-modal-close');

if(sizeGuideBtn){
  sizeGuideBtn.onclick=openSize;
}

if(sizeGuideClose){
  sizeGuideClose.onclick=closeSize;
}

if(modal){
  modal.onclick=e=>{
    if(e.target===modal) closeSize();
  };
}

 // Shopify checkout connection.
 function tierLabel(table,n){
  const x=table.find(t=>n>=t.min&&n<=t.max);
  return x?`${x.min}${x.max>=99999?'+':'–'+x.max}`:null;
 }
 async function loadService(key){
  if(serviceProducts[key])return serviceProducts[key];
  const handle=SERVICES[key];
  const r=await fetch('/products/'+handle+'.js?pcwb='+Date.now(),{cache:'no-store'});
  if(!r.ok)throw new Error('Could not load service product: '+handle);
  serviceProducts[key]=await r.json();
  return serviceProducts[key];
 }
 function serviceVariant(product,table,n){
  if(!product||!product.variants||!product.variants.length)return null;
  if(!table)return product.variants[0];
  const wanted=tierLabel(table,n);
  const normal=s=>String(s||'').toLowerCase().replace(/\s/g,'').replace(/[–—]/g,'-');
  return product.variants.find(v=>{
    const text=[v.title,...(v.options||[])].join(' ');
    const t=normal(text);
    if(n>=50)return /50\+|50plus/.test(t);
    if(n>=25)return /25-49/.test(t);
    if(n>=10)return /10-24/.test(t);
    if(n>=6&&table===EMB)return /6-9/.test(t);
    if(n>=5)return /5-9/.test(t);
    return /1-4/.test(t);
  })||null;
 }
 function addCartItem(items,id,quantity,properties){
  if(!id||!quantity)return;
  items.push({id:+id,quantity:+quantity,properties:properties||{}});
 }
 async function buildShopifyCart(){
  if(!order.length)return;
  const savedPools=decorationPools(false);
  const savedEmbroideryQty=totalEmbroideryPool(savedPools);
  if(savedEmbroideryQty>0&&savedEmbroideryQty<6){
    renderService();
    return;
  }
  const btn=$('#pcwb-checkout');
  const oldText=btn.textContent;
  btn.disabled=true;btn.classList.add('disabled');btn.textContent='BUILDING YOUR ORDER…';
  try{
    const pools=decorationPools(false);
    const items=[];

    // Garments: preserve each exact Shopify colour/size variant.
    for(const line of order){
      const cfg=hasPerformanceOption(line.category)&&line.material==='cool'
        ? CATALOG[line.category].cool
        : CATALOG[line.category][line.tier];
      const key=hasPerformanceOption(line.category)&&line.material==='cool'
        ? line.category+':cool'
        : line.category+':'+line.tier;
      let product=products[key];
      if(!product){
        const r=await fetch('/products/'+cfg.handle+'.js?pcwb='+Date.now(),{cache:'no-store'});
        if(!r.ok)throw new Error('Could not load garment: '+cfg.handle);
        product=products[key]=await r.json();
      }
      for(const [size,count] of Object.entries(line.sizes||{})){
        if(!count)continue;
        const shopifySize=baseSizeKey(size);
        let variant=variantFor(product,line.colour,shopifySize);

        // Ladies Fit is an order instruction, not a separate Shopify variant.
        // Some underlying unisex products do not offer every ladies label
        // (for example XS). In that case use an existing variant in the SAME
        // selected colour purely as the Shopify carrier variant. The actual
        // required ladies size remains explicit in the line-item properties.
        if(!variant && isLadiesSizeKey(size)){
          const ci=optionIndex(product,'colour') ?? optionIndex(product,'color');
          const actual=actualColourFor(product,line.colour);
          variant=product.variants.find(v=>ci===null||variantValue(v,ci)===actual)||null;
        }

        if(!variant)throw new Error(`No Shopify variant found for ${line.colour} / ${shopifySize}`);
        addCartItem(items,variant.id,count,{
          '_Builder':'Print Chimp Uniform',
          'Fit':fitForSizeKey(size),
          'Size':isLadiesSizeKey(size)?`${shopifySize} (UK ${LADIES_UK[shopifySize]})`:shopifySize,
          'Branding':[
            frontPosition(line)==='centreFrontEmb'?'Centre Front Embroidery':frontPosition(line)==='centreFront'?'Centre Front Print':frontPosition(line)==='largeFront'?'Large Front Print':frontPosition(line)==='none'?null:(line.method==='embroidery'?'Left Breast Embroidery':'Left Breast Print'),
            line.back?'Large Back Print':null,
            line.sleeve?`${line.sleeveSide||'Left'} Sleeve Print`:null
          ].filter(Boolean).join(' · ')
        });
      }
    }

    // Decoration products are pooled across the whole order, matching builder pricing.
    if(pools.breastPrint){
      const printQty=totalPrintPool(pools);
      const pr=await loadService('breastPrint'),v=serviceVariant(pr,BREAST,printQty);
      if(!v)throw new Error('Could not match Left Breast Print quantity tier');
      addCartItem(items,v.id,pools.breastPrint,{'Position':'Left Breast','_Artwork':'Logo supplied after ordering'});
    }
    if(pools.centralPrint){
      const printQty=totalPrintPool(pools);
      const pr=await loadService('centralPrint'),v=serviceVariant(pr,BREAST,printQty);
      if(!v)throw new Error('Could not match Central Print quantity tier');
      addCartItem(items,v.id,pools.centralPrint,{'Position':'Centre Front','_Artwork':'Logo supplied after ordering'});
    }
    if(pools.centralEmb){
      const embQty=totalEmbroideryPool(pools);
      const pr=await loadService('centralEmb'),v=serviceVariant(pr,EMB,embQty);
      if(!v)throw new Error('Could not match Centre Front Embroidery quantity tier');
      addCartItem(items,v.id,pools.centralEmb,{'Position':'Centre Front','_Artwork':'Logo supplied after ordering'});
    }
    if(pools.largeFront){
      const printQty=totalPrintPool(pools);
      const pr=await loadService('largeFrontPrint'),v=serviceVariant(pr,BACK,printQty);
      if(!v)throw new Error('Could not match Large Front Print quantity tier');
      addCartItem(items,v.id,pools.largeFront,{'Position':'Large Front','_Artwork':'Logo/design supplied after ordering'});
    }
    if(pools.breastEmb){
      const embQty=totalEmbroideryPool(pools);
      const pr=await loadService('breastEmb'),v=serviceVariant(pr,EMB,embQty);
      if(!v)throw new Error('Could not match Left Breast Embroidery quantity tier');
      addCartItem(items,v.id,pools.breastEmb,{'Position':'Left Breast','_Artwork':'Logo supplied after ordering'});
    }
    if(pools.back){
      const printQty=totalPrintPool(pools);
      const pr=await loadService('backPrint'),v=serviceVariant(pr,BACK,printQty);
      if(!v)throw new Error('Could not match Large Back Print quantity tier');
      addCartItem(items,v.id,pools.back,{'Position':'Large Back','_Artwork':'Logo supplied after ordering'});
    }

    // Sleeve print services are grouped by side and pooled across the whole order.
    const sleeveGroups={};
    order.filter(x=>x.sleeve).forEach(x=>{
      const side=x.sleeveSide||'Left';
      if(!sleeveGroups[side])sleeveGroups[side]={side,qty:0};
      sleeveGroups[side].qty+=(+x.qty||0);
    });
    for(const g of Object.values(sleeveGroups)){
      const printQty=totalPrintPool(pools);
      const pr=await loadService('sleevePrint'),v=serviceVariant(pr,SLEEVE,printQty);
      if(!v)throw new Error('Could not match Sleeve Print quantity tier');
      addCartItem(items,v.id,g.qty,{
        'Position':g.side+' Sleeve',
        '_Artwork':'Logo/design supplied after ordering'
      });
    }

    // One setup charge if this order contains a new embroidery logo.
    if(embroiderySetupTotal(order)){
      const pr=await loadService('embSetup');
      addCartItem(items,pr.variants[0].id,1,{'Setup':'New embroidery logo'});
    }

    // Production upgrade is charged once per garment.
    const garmentQty=order.reduce((sum,x)=>sum+(+x.qty||0),0);
    if(state.service==='fast'){
      const pr=await loadService('fast');
      addCartItem(items,pr.variants[0].id,garmentQty,{'Service':'Fast · 5–7 working days from artwork approval'});
    }else if(state.service==='express'){
      const pr=await loadService('express');
      addCartItem(items,pr.variants[0].id,garmentQty,{'Service':'Express · 3–5 working days from artwork approval'});
    }

    // Start with a clean cart so old unrelated items cannot distort this configured order.
    let r=await fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'}});
    if(!r.ok)throw new Error('Could not prepare Shopify cart');

    r=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items})
    });
    if(!r.ok){
      let detail='';
      try{detail=(await r.json()).description||''}catch(e){}
      throw new Error(detail||'Shopify could not add the configured order');
    }
    window.location.href='/cart';
  }catch(err){
    console.error('Print Chimp checkout:',err);
    alert('We could not build your Shopify cart. '+err.message+'. Please check the service product handles/variants and try again.');
    btn.disabled=false;btn.classList.remove('disabled');btn.textContent=oldText;
  }
 }
 $('#pcwb-checkout').onclick=buildShopifyCart;

 function ensureVestButtons(){
  const addVest=(wrap,complete=false)=>{
   if(!wrap||wrap.querySelector('[data-start="vests"]'))return;
   const btn=document.createElement('button');
   btn.className=complete?'':'pcwb-garment';
   btn.dataset.start='vests';
   btn.innerHTML='<div class="pcwb-garment-img tee"></div><b>VESTS</b><small>'+(complete?'Lightweight merch for events & sports.':'Cotton & sports options for events and teams.')+'</small>';
   btn.onclick=()=>{
    kitTarget=null;
    setCategory('vests',true);
   };
   const tshirt=wrap.querySelector('[data-start="tshirts"]');
   if(tshirt&&tshirt.nextSibling)wrap.insertBefore(btn,tshirt.nextSibling);
   else if(tshirt)wrap.appendChild(btn);
   else wrap.appendChild(btn);
  };
  addVest($('.pcwb-garment-strip'));
  addVest($('.pcwb-complete-grid'),true);
 }
 function ensureApronButtons(){
  const addApron=(wrap,complete=false)=>{
    if(!wrap||wrap.querySelector('[data-start="aprons"]'))return;

    const btn=document.createElement('button');
    btn.className=complete?'':'pcwb-garment';
    btn.dataset.start='aprons';

    btn.innerHTML=
      '<div class="pcwb-garment-img apron"></div>'+
      '<b>APRONS</b>'+
      '<small>'+(complete
        ? 'Smart branded aprons for your team.'
        : 'Perfect for coffee shops & hospitality.'
      )+'</small>';

    btn.onclick=()=>{
      kitTarget=null;
      setCategory('aprons',true);
    };

    const cap=wrap.querySelector('[data-start="caps"]');

    if(cap&&cap.nextSibling)wrap.insertBefore(btn,cap.nextSibling);
    else if(cap)wrap.appendChild(btn);
    else wrap.appendChild(btn);
  };

  addApron($('.pcwb-garment-strip'));
  addApron($('.pcwb-complete-grid'),true);
}
 async function init(){
  ensureVestButtons();
  ensureApronButtons();
  applyMerchCardImages();
  const params=new URLSearchParams(location.search);
  const trade=params.get('trade')||params.get('industry');
  const audience=params.get('for')||params.get('audience');
  const kit=params.get('kit');
  const start=params.get('start')||'tshirts';

  tradePersonalise(trade);
  uniformPersonalise(audience);
  activeKit=KITS[kit]?kit:null;

  if(activeKit){
    const first=KITS[activeKit].items[0];
    kitTarget={category:first.category,qty:first.qty};
    await setCategory(first.category,false);
    renderKit();
    $('#pcwb-kit').scrollIntoView({behavior:'smooth',block:'start'});
  }else{
    await setCategory(CATALOG[start]?start:'tshirts',false);
  }
 }
 init();
})();